import { render, staticRenderFns } from "./SignaturesStatistics.vue?vue&type=template&id=0c00d698&scoped=true"
import script from "./SignaturesStatistics.vue?vue&type=script&lang=js"
export * from "./SignaturesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c00d698",
  null
  
)

export default component.exports